import React from 'react'

export class XlsxRender extends React.Component {

    render () {
        const { step } = this.props
        return (
            <>
                <iframe
                    className="w-100 h-md-700px"
                    frameBorder="0"
                    title="Excel Render"
                    src={`https://view.officeapps.live.com/op/embed.aspx?src=`+ step.content}
                    />
            </>
        )
    }
} 